<div class="container-fluid h-100">
  <div class="row h-100">
    <div class="col-sm-6 col-lg-6 col-xl-7 pr-0 pl-0 h-100 main-container model-image">
    </div>
@if (productId) {
  <div class="col-sm-6 col-lg-6 col-xl-5 h-100">
    <div class="h-100">
      <!--        <app-model-information (modelImage)="extractProductImage($event)"-->
    <!--                               [productId]="productId" [categoryId]="categoryId"></app-model-information>-->
    <app-model-elements [productId]="productId" [categoryId]="categoryId"></app-model-elements>
    <!--        <app-model-actions [productId]="productId"></app-model-actions>-->
  </div>
</div>
}
</div>
</div>
